if(!customElements.get('announcement-slider')) {
  customElements.define('announcement-slider', class AnnouncementSlider extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector('.swiper');
      if(!this.slider) return;
      this.calculateHeight();
      this.init();
    }

    get speed() {
      return Number(this.dataset.speed);
    }

    init() {
      window.loadSwiper.then(({ Swiper }) => {
        const options = {
          direction: 'vertical',
          slidesPerView: 1,
          loop: true,
          autoplay: {
            delay: this.speed,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
          },
          speed: 400
        }

        new Swiper(this.slider, options);
      })
    }
    
    calculateHeight() {
      const blocks = document.querySelectorAll('[data-block]');
      const maxHeight = [...blocks].reduce((max, block) => 
        Math.max(max, block.offsetHeight), 0
      );
      
      this.style.height = maxHeight + 'px';
    }
  })
}